var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { autoinject, transient } from "aurelia-dependency-injection";
import { CurrencyEnum } from '../../../../../models/modules/lotteryplatofrm.models';
import { ChildComponent } from "../../../../pages/modules/child-component";
import { NotificationClientService } from "../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import { TokenClient } from '../../../../../services/authentication/token-client.service';
import { LookupValueRequest, LookupValueQuery, ConfirmationDialogModel } from "../../../../../models/lookups/lookup.models";
import { LookupClientService } from "../../../../../services/lookups/lookup-client.service";
import * as Enumerable from "linq";
import { UserClaimsService } from "../../../../../services/authentication/user-claims.service";
import { DialogServiceConstants } from "../../../../../constants/basics/dialog.constants";
import { DialogClientService } from "../../../../../services/basics/dialog-client.service";
import { QueriesClientService } from "../../../../../services/queries/queries-client.services";
import { RequestClient } from '../../../../../services/basics/request-client.service';
import { LotteriesByOperatorCurrencyDialog } from "../dialogs/lotteries-by-operator-currency-dialog";
import { BrandsByOperatorCurrencyDialog } from "../dialogs/brands-by-operator-currency-dialog";
var OperatorSettings = /** @class */ (function (_super) {
    __extends(OperatorSettings, _super);
    function OperatorSettings(notificationService, i18N, tokenClientService, lookupClientService, userClaimsService, queriesService, dialogClient, requestClient, lotterybyoperatorcurrency, brandsByOperatorCurrencies) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.tokenClientService = tokenClientService;
        _this.lookupClientService = lookupClientService;
        _this.userClaimsService = userClaimsService;
        _this.queriesService = queriesService;
        _this.dialogClient = dialogClient;
        _this.requestClient = requestClient;
        _this.lotterybyoperatorcurrency = lotterybyoperatorcurrency;
        _this.brandsByOperatorCurrencies = brandsByOperatorCurrencies;
        _this.allCurrencies = [];
        _this.showCurrencyName = "";
        _this.shouldCheckCurrency = false;
        return _this;
    }
    //@computedFrom("item.isEditable")
    OperatorSettings.prototype.isEuro = function (currency) {
        return currency.id == CurrencyEnum.Euro;
    };
    OperatorSettings.prototype.doesTheOperatorHasThisCurrency = function (currency) {
        // Euro currency checkbox should be true by default and check for other currencies which are already saved in operator curencies table 
        return currency.id == CurrencyEnum.Euro || Enumerable.from(this.item.operatorCurrencies).any(function (x) { return x.currencyId == currency.id; });
    };
    OperatorSettings.prototype.isCurrencyDefault = function (currency) {
        return this.item.defaultCurrencyId == currency.id;
    };
    OperatorSettings.prototype.setCurrencyAsDefault = function (event, currency) {
        if (Enumerable.from(this.item.operatorCurrencies).any(function (x) { return x.currencyId == currency.id; })) {
            if (event.detail.value) {
                this.item.defaultCurrencyId = currency.id;
            }
        }
    };
    OperatorSettings.prototype.validateClickEvent = function (event, currency) {
        return __awaiter(this, void 0, void 0, function () {
            var brandsAndOperatorsModel, lotteryLengthDependsOnselectedCurrency;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(currency.id == CurrencyEnum.Euro)) return [3 /*break*/, 1];
                        return [2 /*return*/, true]; // return true for check box checked.
                    case 1:
                        if (!currency.selected) return [3 /*break*/, 2];
                        this.brandListDialog(currency);
                        return [3 /*break*/, 4];
                    case 2:
                        brandsAndOperatorsModel = {
                            operatorId: this.item.operatorId,
                            currencyId: currency.id
                        };
                        return [4 /*yield*/, this.lotterybyoperatorcurrency.createDataGridList(brandsAndOperatorsModel, 0).then(function (e) { return e; })];
                    case 3:
                        lotteryLengthDependsOnselectedCurrency = _a.sent();
                        // if this selected currency is assigned for all lotteries ticketprices.
                        if (lotteryLengthDependsOnselectedCurrency != 0) {
                            require("../../operator/dialogs/lotteries-by-operator-currency-dialog");
                            this.dialogClient.show(DialogServiceConstants.URLs.LotteriesByOperatorCurrencies, brandsAndOperatorsModel);
                            currency.selected = false;
                            return [2 /*return*/, false];
                        }
                        return [2 /*return*/, true];
                    case 4: return [2 /*return*/, false];
                }
            });
        });
    };
    OperatorSettings.prototype.confirmationDialog = function (currency) {
        return __awaiter(this, void 0, void 0, function () {
            var confirmModel;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // when trying to change checkbox from true to false, open a pop up to confirmation
                        require("../../dialogs/confirmation-dialog");
                        confirmModel = new ConfirmationDialogModel();
                        // title message 'Are you sure you want to save?' which is mentioned in en.json file
                        confirmModel.headerTitle = "change-confirmation";
                        // alert message as depends on header title which is also mentioned in en.json file. 
                        //the message is 'when uncheck operator currency, all ticket prices by this currency will get afected'
                        confirmModel.headerMessage = "currency-ticket-price-override-warning-text";
                        confirmModel.headerMessageTranslateProps = {
                            currencyName: currency.name
                        };
                        // click 'yes' from pop up to remove check box item from brand currency list
                        return [4 /*yield*/, this.dialogClient.show(DialogServiceConstants.URLs.ConfirmationDialog, {
                                confirmModel: confirmModel,
                                save: function () { return new Promise(function (resolves, reject) {
                                    _this.unselectedOperatorCurrency(currency);
                                    currency.selected = false;
                                    _this.dialogClient.hide();
                                    return false;
                                }); },
                                hide: function () { return new Promise(function () {
                                    currency.selected = true;
                                    _this.dialogClient.hide();
                                    return true;
                                }); }
                            })];
                    case 1:
                        // click 'yes' from pop up to remove check box item from brand currency list
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    OperatorSettings.prototype.brandListDialog = function (currency) {
        return __awaiter(this, void 0, void 0, function () {
            var brandsAndOperatorsModel, brandLength;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        brandsAndOperatorsModel = {
                            operatorId: this.item.operatorId,
                            currencyId: currency.id,
                        };
                        return [4 /*yield*/, this.brandsByOperatorCurrencies.createDataGridList(brandsAndOperatorsModel, 0).then(function (e) { return e; })];
                    case 1:
                        brandLength = _a.sent();
                        if (brandLength != 0) {
                            // show the brand list which has operator curency
                            require("../../operator/dialogs/brands-by-operator-currency-dialog");
                            this.dialogClient.show(DialogServiceConstants.URLs.BrandsByOperatorCurrencies, brandsAndOperatorsModel, true, true);
                        }
                        else {
                            // if currency has no brand curency set, then directly call for confirmation dialog to unselect the currency from operator 
                            this.confirmationDialog(currency);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    OperatorSettings.prototype.unselectedOperatorCurrency = function (currency) {
        var operatorCurrency = Enumerable.from(this.item.operatorCurrencies).firstOrDefault(function (x) { return x.currencyId == currency.id; });
        var operatorCurrencyIndex = this.item.operatorCurrencies.indexOf(operatorCurrency);
        this.item.operatorCurrencies.splice(operatorCurrencyIndex, 1);
    };
    // call this function when validate check event return true.
    OperatorSettings.prototype.assignCurrencyOnChange = function (event, currency) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (Enumerable.from(this.item.operatorCurrencies).count(function (x) { return x.currencyId == currency.id; }) == 0) {
                    this.item.operatorCurrencies.push({ currencyId: currency.id, operatorId: this.item.operatorId });
                }
                currency.selected = true;
                return [2 /*return*/];
            });
        });
    };
    // Needs to add function for validate on click for currency check box
    OperatorSettings.prototype.attached = function () {
        var _this = this;
        var currencyPromise = this.getAllCurrencies();
        Promise.all([currencyPromise]).then(function () {
            if (!_this.item.operatorId) {
                var euroDefault = Enumerable.from(_this.allCurrencies).firstOrDefault(function (s) { return s.id == CurrencyEnum.Euro; });
                var defaultCurrency = euroDefault ? euroDefault.id : _this.allCurrencies[0].id;
                _this.item.operatorCurrencies.push({ currencyId: defaultCurrency });
                _this.item.defaultCurrencyId = defaultCurrency;
            }
        });
    };
    OperatorSettings.prototype.getAllCurrencies = function () {
        var _this = this;
        var request = new LookupValueRequest();
        var selecatbleCurrencies = [];
        request.lookupValueQuery = LookupValueQuery.currencies;
        return this.lookupClientService.getLookup(request).then(function (x) {
            // this if enter when creating new operator
            if (_this.item.operatorId == null || _this.item.operatorId == 0) {
                x.values.filter(function (e) { return e.id == CurrencyEnum.Euro; }).map(function (lv) {
                    var slv = lv;
                    slv.selected = slv.id == CurrencyEnum.Euro; // by default set euro as assigned on creating new operator
                    selecatbleCurrencies.push(slv);
                });
            }
            else {
                x.values.map(function (lv) {
                    var slv = lv;
                    slv.selected = _this.doesTheOperatorHasThisCurrency(slv);
                    selecatbleCurrencies.push(slv);
                });
            }
            _this.allCurrencies = selecatbleCurrencies;
        });
    };
    OperatorSettings = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService,
            I18N,
            TokenClient,
            LookupClientService,
            UserClaimsService,
            QueriesClientService,
            DialogClientService,
            RequestClient,
            LotteriesByOperatorCurrencyDialog,
            BrandsByOperatorCurrencyDialog])
    ], OperatorSettings);
    return OperatorSettings;
}(ChildComponent));
export { OperatorSettings };
